export const CHOOSE_DATES = "Choose Dates";
export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
export const SEARCH_HOTELS = "Search Hotels";
